export default __webpack_public_path__ + "static/media/GD.3388789e.svg";